import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Content Analytics page */
export default class RediscoverOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    run: PropTypes.bool.isRequired,
    selectedNetwork: PropTypes.string
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Content Analysis dashboard for {this.props.selectedNetwork}!<br/><br/>This Media Map displays a network or platform’s share of content in key genres.<br/><br/>Proximity of data points in the visualization indicate a heavier overlap and/or similarity of audience members.</p>),
        disableBeacon: true,
        target: '.nsewdrag' // class name of the plotly map
      },
      {
        ...common,
        content: (<p>Complementary statistics provide engagement and demographic insights about audiences at the genre level.<br/><br/>They also highlightt catalog volume and engagement insights for each network or platform on a rolling 18 month basis.<br/><br/>Let's Go!</p>),
        target: '#rediscoverRight'
      },
      {
        ...common,
        content: (<p>Toggle to the Explore dashboard to visualize the entire media landscape broken out by other parameters such as distribution source or network.<br/><br/>Let's Go!</p>),
        target: '#discoverNav'
      }
    ]

    return steps
  }
}
